var map = {
	"./app/zhCHT/second.jpg": "eb96",
	"./app/zhEn/second.jpg": "43ed",
	"./pc/zhCHT/second.jpg": "fe64",
	"./pc/zhEn/second.jpg": "8695"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb3b";